import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { PortalLogtoClient, type PortalNotificationOptions } from '@reflact/portal-ecosystem';

interface LogtoConfigResponse {
  status: string;
  endpoint?: string;
  appId?: string;
  resource?: string;
  notificationHubUrl?: string;
  notificationResource?: string;
}

@Injectable({ providedIn: 'root' })
export class LogtoService extends PortalLogtoClient {
  readonly accountUrl = signal('');
  readonly notificationOptions = signal<PortalNotificationOptions | undefined>(undefined);
  constructor(http: HttpClient) {
    super(async () => {
      const config = await firstValueFrom(http.get<LogtoConfigResponse>('/api/auth/logtoConfig'));
      if (config.status !== 'ok' || !config.endpoint || !config.appId) {
        throw new Error('Logto ist auf diesem Server nicht konfiguriert.');
      }
      this.accountUrl.set(new URL('account/', config.endpoint.replace(/\/$/, '') + '/').toString());
      if (config.notificationHubUrl && config.notificationResource) {
        this.notificationOptions.set({
          baseUrl: config.notificationHubUrl,
          getAccessToken: () => this.getResourceToken(config.notificationResource!)
        });
      }
      return {
        endpoint: config.endpoint, appId: config.appId, resource: config.resource,
        notificationResource: config.notificationResource
      };
    });
  }
}
